import React from 'react';

/**
 * Elevator Component
 * 
 * Exactly matches the legacy site's elevator section
 */
const Elevator = () => {
  return (
    <div className="tool-overview-container">
      <div className="tool-breadcrumb-container">
        <div className="tool-breadcrumb-wrap">
          <div className="tool-breadcrumb-icon"><i className="fas fa-bullhorn fa-2x"></i><h6></h6></div>
          <div className="tool-breadcrumb-nav">R&D Toolkit&nbsp;&nbsp;<i className="fas fa-angle-double-right"></i>&nbsp;&nbsp;Welcome</div>
          <div className="tool-breadcrumb-title">Product R&D Toolkit</div>
        </div>
      </div>

      <div className="tool-welcome-para">
        <p>
          Welcome to my Product R&D Toolkit. A place for the various tools, frameworks and processes that I use in order to launch and develop digital products in a lean, rapid manner.
        </p>
        
        <p>
          It also contains a wealth of other resources that will help immensely with the Product innovation process - I also welcome and encourage collaboration where possible, so feel free to get in contact via the chat window (bottom right), LinkedIn or the email found on the about page. 
        </p>
      </div>
    </div>
  );
};

export default Elevator; 